import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.reportingAPI;

async function search(props) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportDefinitionParameters/search',
        body: JSON.stringify(props),
      }, API))
  );
}

async function getById(reportDefinitionParameterID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/reportDefinitionParameters/${reportDefinitionParameterID}`
      }, API))
  );
}

async function create(reportDefinitionParameter) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportDefinitionParameters',
        body: JSON.stringify(reportDefinitionParameter)
      }, API))
  );
}

async function update(reportDefinitionParameter) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/reportDefinitionParameters/${reportDefinitionParameter.reportDefinitionParameterID}`,
        body: JSON.stringify(reportDefinitionParameter)
      }, API))
  );
}

// lowercase delete is a reserved word in javascript
async function Delete(reportDefinitionParameterID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/reportDefinitionParameters/${reportDefinitionParameterID}`
      }, API))
  );
}

const reportDefinitionParameterService = {
  search,
  getById,
  create,
  update,
  delete: Delete
};

export default reportDefinitionParameterService;
